import {useNavigate} from "react-router-dom";
import {Box, Button, Grid, Typography} from "@mui/material";
import MicIcon from '@mui/icons-material/Mic';
import {useAuth} from "../../usermanagement/AuthProvider";
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import InfoPage from "./InfoPage";

export default function Header() {
    const {username, logout} = useAuth();
    const nav = useNavigate();

    return (
        <Box display={'flex'} justifyContent={'center'} m={1} mt={1.5}>
            <Grid container
                  border={0.1} borderColor={"lightgrey"} borderRadius={2}
                  mt={1} ml={1} mr={1} mb={2}
                  flexGrow={1} justifyContent={'center'} alignItems={'center'}
            >
                <Grid size={4}>
                    <Grid container direction={"row"} wrap={"nowrap"}>
                        <Grid mr={2} ml={1}>
                            {
                                username &&
                                <MicIcon color={'primary'} onClick={() => nav("/record")}/>
                            }
                        </Grid>
                        <Grid>
                            <InfoPage/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={4}>
                    <Grid container justifyContent={'center'}>
                        <Button onClick={() => nav("/")}>
                            <Typography variant={"h4"} color={"lightseagreen"}>
                                {process.env.REACT_APP_APPLICATION_NAME}
                            </Typography>
                        </Button>
                    </Grid>
                </Grid>
                <Grid size={4}>
                    <Grid container justifyContent={'end'} justifyItems={'end'} alignItems={'center'}>
                        <Grid>
                            {username ?
                                <Grid container direction={'row'} alignItems={'center'} justifyItems={'end'}
                                      wrap={'nowrap'}>
                                    <Grid mr={2}>
                                        <LogoutIcon onClick={logout} color={'primary'}/>
                                    </Grid>
                                    <Grid ml={0} mr={1}>
                                        <PersonIcon color={"primary"} onClick={() => nav("/userpage")}/>
                                    </Grid>
                                </Grid>
                                :
                                <Grid container direction={'column'}>
                                    <Grid>
                                        <Button color="inherit" size={"small"} onClick={() => nav("/login")}>
                                            Login
                                        </Button>
                                    </Grid>
                                    <Grid>
                                        <Button color="inherit" size={"small"} onClick={() => nav("/register")}>
                                            Register
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}